import { HttpClient, HttpEvent } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class CaseDetailService {

  baseUrl = environment.baseUrl;
  updateChat: boolean=false;
  messageStatus: boolean = false;
  onsite = 0
  parts = 0
  lionPrinters: any[]=[];
  constructor(private http: HttpClient) { }

  get ChatFlag(){
    return this.updateChat
  }

  setChatFlag(item){
    console.log(item)
    this.updateChat=item
  }

  getCaseDetails(id) {
    return this.http.get<any>(this.baseUrl + `/services/case/api/v1/case_detail?case_id=${id}`)
  }

  getCaseStatusAndPriority() {
   return this.http.get<any>(this.baseUrl + '/services/case/api/v1/users');
  }

  getUsers() {
    return this.http.get<any>(this.baseUrl + '/services/core/users/api/v1/reseller/users');
  }

  getElevatedStatus(model) {
    return this.http.get<any>(this.baseUrl + `/services/sc/api/v1/model_supports_elevation?model=${model}`);
  }

  getCaseActivities(id): Observable<any> {
    return this.http.get<any>(this.baseUrl + '/services/case/api/v1/hp_case_activities?case_id='+id).pipe(map(response => {
      return response.result;
    }));
  }

  getCaseAddidtionalInfo(body) {
    return this.http.post<any>(this.baseUrl + `/services/seals/api/v1/alerts/get_alert_solution`, body)
  }

  getCustomerContactInfo(cust_id) {
    return this.http.get<any>(this.baseUrl + '/services/core/users/api/v1/contact_info?customer_contact_id=' + cust_id)
  }

  saveNewActivity(id,body){
    return this.http.post<any>(this.baseUrl+`/services/case/api/v1/hp_case_activities?case_id=`+id,body)
  }

  deleteCaseActivity(id,caseId){
    return this.http.delete<any>(this.baseUrl+`/services/case/api/v1/hp_case_activities/`+id+`?case_id=`+caseId)
  }

  updateCaseActivity(id,activityId,body){
    return this.http.put<any>(this.baseUrl+`/services/case/api/v1/hp_case_activities/`+activityId+`?case_id=`+id,body)
  }

  assignOwner(userID, caseID) {
    return this.http.post<any>(this.baseUrl + `/services/case/api/v1/assign_owner?user_id=${userID}&case_id=${caseID}`, '')
  }

  setPriority(caseID, priority) {
    return this.http.post<any>(this.baseUrl + `/services/case/api/v1/set_case_priority?case_id=${caseID}&priority=${priority}`, '')
  }

  setStatus(caseID, data) {
    return this.http.post<any>(this.baseUrl + `/services/case/api/v1/update_status?case_id=${caseID}`, data)
  }

  getLocation(){
    return this.http.get<any>(this.baseUrl+`/services/core/api/printos/v1/locations`)
  }

  downLoadReport(url) {
    return this.http.get<Blob>(url, {observe: 'response', responseType: 'blob' as 'json'});
  }

  getCaseList(serialNum,productNum){
    return this.http.get<any>(this.baseUrl+`/services/case/api/v1/printer_case_list?serial_number=${serialNum}&product_number=${productNum}`)
  }
  getOnsiteActivity(caseId){
    return this.http.get<any>(this.baseUrl+`/services/case/api/v1/onsite_activities?case_id=${caseId}`)
  }
  getPartActivity(caseId){
    return this.http.get<any>(this.baseUrl+`/services/case/api/v1/parts_activities?case_id=${caseId}`)
  }
  onElevatecase(postData){
    return this.http.post<any>(this.baseUrl + '/services/case/api/v2/elevate_case', postData)
  }

  presignedUploadCase(caseID, payload) {
   return this.http.post<any>(this.baseUrl + `/services/case/api/v1/presigned_url?case_id=${caseID}`, payload)
  }

  passPresignedUrl(url, newData): Observable<HttpEvent<any>>{
    return this.http.post(url, newData, {    
      reportProgress: true,
     observe: 'events',});
  }  

  uploadCaseFile(caseID, payload) {
     return this.http.post<any>(this.baseUrl + `/services/case/api/v1/upload_case_files?case_id=${caseID}`, payload)
  }

  // uploadFile(data) : Observable<HttpEvent<any>>{
  //   return this.http.post<any>(this.baseUrl + '/services/case/api/v1/upload_case_file', data, { reportProgress: true,
  //     observe: 'events',})
  // }
  deleteFile(caseId,fileId){
    return this.http.delete<any>(this.baseUrl+`/services/case/api/v1/delete_case_file?case_id=${caseId}&file_id=${fileId}`)
  }
  createNewSite(sitePayload) {
    return this.http.post<any>(this.baseUrl + '/services/core/users/api/v1/add_psp_site', sitePayload)
  }
  getLionPrinters() {
    this.http.get<any>(this.baseUrl + '/services/sc/api/v1/elevation_supported_models').pipe(tap(res => {
     res.result.forEach(element => {
       this.lionPrinters.push(element.name);

     });
    })).subscribe();
  }
  includesLionPrinters(element) {
    if(this.lionPrinters.length) {
      return (this.lionPrinters.includes(element.printer_model) || this.lionPrinters.includes(element.product_number));
    }
  }
  addNewSite(sitePayload) {
    return this.http.post<any>(this.baseUrl + '/services/core/api/printos/v1/locations', sitePayload)
  }

  getProAction(payload) {
    return this.http.get<any>(this.baseUrl + `/services/seals/api/v1/actions?serial_number=${payload.sn}&product_number=${payload.pn}`)
  }

  getSolution(actionID) {
    return this.http.get<any>(this.baseUrl + `/services/seals/api/v1/get_solution?action_id=${actionID}`)
  }
  getFeedback(action_id){
    return this.http.get<any>(this.baseUrl + '/services/seals/api/v1/feedback?action_id=' + action_id)
  }
  getCaseIDFromAction(actionID) {
    return this.http.get<any>(this.baseUrl + `/services/case/api/v1/hp_case_of_alert?action_id=${actionID}`)
  }
  closeAction(actionID) {
    return this.http.post<any>(this.baseUrl + `/services/seals/api/v1/close_action?action_id=${actionID}`, '')
  }
  
 getFileFormat(bytes) {
   const sizes = ['KB', 'MB', 'GB', 'TB'];
    if(bytes == 0) return '0 MB'
    if (bytes < 1024) return `${(bytes / 1024).toFixed(4)} KB`; // Convert bytes to KB and show in decimal
    const i = Math.floor(Math.log(bytes) / Math.log(1024)) - 1;
    const fileSize = parseFloat((bytes / Math.pow(1024, i + 1)).toFixed(2)); // 2 decimal places
    return `${fileSize} ${sizes[i]}`;
 }

}

